'use client'

import { useTRPC } from '@/trpc/react'
import { UserWithClientIdAndUserRoles } from '@/types/router-queries'
import { useQuery } from '@tanstack/react-query'
import { createContext, useContext } from 'react'

export interface AuthState {
  // user: DbUser | undefined
  user: UserWithClientIdAndUserRoles | undefined
  clientId: string | undefined
  isPending: boolean
  error: Error | null
  isAuthenticated: boolean | undefined
  isUserOnboarded: boolean | undefined
}

export interface AuthProviderProps {
  children: React.ReactNode
}

const AuthContext = createContext<AuthState | null>(null)

export function AuthProvider({ children }: AuthProviderProps) {
  const api = useTRPC()
  const { data, isPending, isError } = useQuery({
    ...api.user.getUserWithClientId.queryOptions(),
    retry: 1,
    retryDelay: 1000,
  })

  return (
    <AuthContext.Provider
      value={{
        user: data ? data : undefined,
        clientId: data?.employee?.clientId ?? undefined,
        isPending,
        error: isError ? new Error('Failed to fetch user') : null,
        isAuthenticated: data?.userId != null && data?.name != null,
        isUserOnboarded: data?.isUserOnboarded ?? false,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  console.log({ useAuthContext: context })
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
